export default __webpack_public_path__ + "static/media/map-pin-white.572cacd9.svg";